import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import PollingFrequencyDataService from "../../services/polling-frequency-data-service/PollingFrequencyDataService";
import { IPollingScheduleDataModel } from "../../services/polling-frequency-data-service/Models";

export type UsePollingFrequencyDataParameters = {
    contextGroupID: number;
} & BaseUseQueryParameters<IPollingScheduleDataModel>;

export function usePollingFrequencyData({
    contextGroupID,
    onError,
    onSuccess
}: UsePollingFrequencyDataParameters) {
    return useQuery<IPollingScheduleDataModel, RestError>(
        keys.data(contextGroupID),
        ({ signal }) => {
            return PollingFrequencyDataService.getPollingFrequencyData(contextGroupID, signal);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: 0,
            refetchOnWindowFocus: false

        }
    );
}
